import {has} from "lodash"

import Communication from "../../../images/drivers/Communication.svg"
import EmployeeManagerRelations from "../../../images/drivers/EmployeeManagerRelations.svg"
import LearningAndDevelopment from "../../../images/drivers/LearningAndDevelopment.svg"
import MyWork from "../../../images/drivers/MyWork.svg"
import Opportunities from "../../../images/drivers/Opportunities.svg"
import QualityOfLife from "../../../images/drivers/QualityOfLife.svg"
import RewardAndRecognition from "../../../images/drivers/RewardAndRecognition.svg"
import StrategyAndLeadership from "../../../images/drivers/StrategyAndLeadership.svg"
import Teamwork from "../../../images/drivers/Teamwork.svg"
import TheOrganisationAndCulture from "../../../images/drivers/TheOrganisationAndCulture.svg"


/** Initial helper reference */
const helper = {}


const driverImages = {
  "insights.driver.strategyAndLeadership": StrategyAndLeadership,
  "insights.driver.communication": Communication,
  "insights.driver.learningAndDevelopment": LearningAndDevelopment,
  "insights.driver.meaningfulWork": MyWork,
  "insights.driver.careerOpportunities": Opportunities,
  "insights.driver.qualityOfLife": QualityOfLife,
  "insights.driver.rewardAndRecognition": RewardAndRecognition,
  "insights.driver.myManager": EmployeeManagerRelations,
  "insights.driver.teamwork": Teamwork,
  "insights.driver.cultureAndDiversity": TheOrganisationAndCulture
}


/**
 *
 * Helper to run common requests
 * @param contentId
 * @returns String
 */

helper.getDriverIcon = (contentId) => (has(driverImages, contentId) ? driverImages[contentId] : EmployeeManagerRelations)

/** export helpers individually */
export const getDriverIcon = helper.getDriverIcon

/** export default helper obj */
export default helper
